import * as S from './styled'

import React, { FunctionComponent } from 'react'
import { ActivityIndicator } from 'react-native'

import theme from '@app/ui/theme'

type Props = {
  accept?: boolean
  reject?: boolean
  onPress: () => void
  text: string
  sameSize?: boolean
  pressed?: boolean
  destructive?: boolean
  loading?: boolean
  inactive?: boolean
}

const AcceptRejectButton: FunctionComponent<Props> = ({
  accept,
  reject,
  onPress,
  text,
  sameSize,
  pressed,
  destructive,
  loading,
  inactive,
}) => {
  return (
    <S.ButtonContainer
      onPress={pressed || loading || inactive ? null : onPress}
      backgroundColor={accept ? theme.colors.accept : theme.colors.reject}
      width={sameSize ? 128 : accept ? 128 : 105}
      pressed={pressed}
      destructive={destructive}
      loading={loading}
      inactive={inactive}
    >
      {loading ? (
        <ActivityIndicator
          color={destructive ? theme.colors.warning : theme.colors.accept}
        />
      ) : (
        <S.ButtonText color={reject}>{text}</S.ButtonText>
      )}
    </S.ButtonContainer>
  )
}

export default AcceptRejectButton
